var _circle, _circle2, _circle3, _circle4, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9993,
    cy: 11.0026,
    r: 0.916667,
    transform: "rotate(90 10.9993 11.0026)",
    stroke: "#4B465C",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9993,
    cy: 11.0026,
    r: 0.916667,
    transform: "rotate(90 10.9993 11.0026)",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.58333,
    cy: 11.0026,
    r: 0.916667,
    transform: "rotate(90 4.58333 11.0026)",
    stroke: "#4B465C",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.58333,
    cy: 11.0026,
    r: 0.916667,
    transform: "rotate(90 4.58333 11.0026)",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.4173,
    cy: 11.0026,
    rx: 0.916667,
    ry: 0.916667,
    transform: "rotate(90 17.4173 11.0026)",
    stroke: "#4B465C",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.4173,
    cy: 11.0026,
    rx: 0.916667,
    ry: 0.916667,
    transform: "rotate(90 17.4173 11.0026)",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/action.abeb21ee437557ab6055a864c5daa9e3.svg";
export { ForwardRef as ReactComponent };